import axios from "axios";
import Swal from "sweetalert2";

let showingSessionExpired = false;

function redirectToLogin() {
  const loginUrl = process.env.REACT_APP_LOGOUT_URL || "/login";
  window.location.replace(loginUrl);
}

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    try {
      const status = error?.response?.status || error?.status;
      if (status === 401) {
        if (showingSessionExpired) return Promise.reject(error);
        showingSessionExpired = true;

        await Swal.fire({
          title: "Sesión expirada",
          text: "Tu sesión ha expirado. Por favor vuelve a iniciar sesión.",
          icon: "warning",
          confirmButtonText: "Iniciar sesión",
          allowOutsideClick: false,
          allowEscapeKey: false,
        });

        try {
          localStorage.removeItem("token");
          sessionStorage.removeItem("token");
          localStorage.removeItem("lng");
          localStorage.removeItem("auth0.isAuthenticated");
        } catch (e) {
          console.warn("Failed to clear auth state", e);
        }

        redirectToLogin();
      }
    } catch (e) {
      console.warn("Error handling axios response", e);
    } finally {
      showingSessionExpired = false;
    }
    return Promise.reject(error);
  },
);

export default axios;
